import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

type ModalConfirmType = 'danger' | 'warning' | 'info';
type ButtonStyle = 'primary' | 'secondary' | 'success' | 'warning' | 'danger';

interface TypeStyles {
  iconBg: string;
  iconColor: string;
  button: string;
}

export interface ConfirmButton {
  text: string;
  style?: ButtonStyle;
  action: string;
}

@Component({
  selector: 'app-modal-confirm',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-confirm.component.html'
})
export class ModalConfirmComponent {
  @Input() isOpen = false;
  @Input() title = 'Confirmar acción';
  @Input() message = '¿Estás seguro de que quieres continuar?';
  @Input() type: ModalConfirmType = 'danger';
  @Input() buttons: ConfirmButton[] = [];
  @Output() action = new EventEmitter<string>();

  private readonly typeStyles: Record<ModalConfirmType, TypeStyles> = {
    danger: {
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      button: 'bg-red-600 hover:bg-red-500 focus:ring-red-500'
    },
    warning: {
      iconBg: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      button: 'bg-yellow-600 hover:bg-yellow-500 focus:ring-yellow-500'
    },
    info: {
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      button: 'bg-blue-600 hover:bg-blue-500 focus:ring-blue-500'
    }
  };

  private readonly buttonStyles: Record<ButtonStyle, string> = {
    primary: 'bg-blue-600 hover:bg-blue-500 focus:ring-blue-500',
    secondary: 'bg-gray-600 hover:bg-gray-500 focus:ring-gray-500',
    success: 'bg-green-600 hover:bg-green-500 focus:ring-green-500',
    warning: 'bg-yellow-600 hover:bg-yellow-500 focus:ring-yellow-500',
    danger: 'bg-red-600 hover:bg-red-500 focus:ring-red-500'
  };

  get styles(): TypeStyles {
    return this.typeStyles[this.type];
  }

  getButtonClasses(button: ConfirmButton): string {
    const baseClasses = 'inline-flex justify-center rounded-md px-4 py-2 text-sm font-medium shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2';
    
    if (button.action === 'cancel') {
      return `${baseClasses} bg-white text-gray-700 ring-1 ring-gray-300 hover:bg-gray-100 focus:ring-gray-400`;
    }
    
    const styleClass = this.buttonStyles[button.style || 'primary'];
    return `${baseClasses} text-white ${styleClass}`;
  }

  onAction(action: string) {
    this.action.emit(action);
  }
}
